// src/components/Header/Header.js
import React from 'react';
import './Header.css';
import useTestMode from '../../../hooks/useTestMode';
import useVpnHint from '../../../hooks/useVpnHint';

const Header = () => {
    const testMode = useTestMode();
    const { visible: showVpnHint, dismiss: dismissVpnHint } = useVpnHint();

    return (
        <header className="header">
            {testMode && (
                <div className="test-mode-banner" role="status">
                    Тестовый режим
                </div>
            )}
            {showVpnHint && (
                <div className="vpn-hint-banner" role="status">
                    <span>Без VPN всё будет работать быстрее и стабильнее</span>
                    <button
                        type="button"
                        className="vpn-hint-dismiss"
                        onClick={dismissVpnHint}
                        aria-label="Закрыть"
                    >
                        ×
                    </button>
                </div>
            )}
            <div className="container header-container">
                <a className="brand-wordmark" href="/" aria-label="ЭТО РОССИЯ — на главную">
                    это Россия
                </a>
                <nav className="header-nav" aria-label="Основная навигация">
                    <a href="#products">Коллекция</a>
                    <a href="#fit">Как сидит</a>
                    <a href="#about">О бренде</a>
                    <a href="#contacts">Контакты</a>
                </nav>
                <a className="header-shop-link" href="#products">Выбрать вещь</a>
            </div>
        </header>
    );
};

export default Header;
